import { RouteProps } from "../../inplant-core-fe/types";
import Webview from "../ui/components/widgets/Webview/Webview";

export const webviewRoute: RouteProps = {
  path: '/webview',
  visible: false,
  component: Webview,
  i18nkey: ''
}